import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import TableListado from './TableListado';
import VistaDetalle from './VistaDetalle';
import CustomButton from '../../../../ui/CustomButton';
import { useQueryGetUserMe } from '../../../../../../queries/userQueries';
import SearchFilter from '../../../../ui/SearchFilter';
import GlobalContext from '../../../../../../context/global-context';
import { BusinessAPI } from '../../../../../../api/business.api';
import LoaderAdm from '../../../../../../assets/svgIcons/LoaderAdm.json'
import Lottie from 'lottie-react'
import {currentMonth,currentYear,yearsOptions} from '../../../../../utils/constant'
import { Select } from '../../../../ui';
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const List = () => {
  const [dataClienteProv, setDataClienteProv] = useState([])
  const { data: userMe } = useQueryGetUserMe()
  const [selectedTipo, setSelectedTipo] = useState('clientes'); // o 'proveedores'
  const [selectedItem, setSelectedItem] = useState(null); // fila seleccionada
  const [searchTerm, setSearchTerm] = useState('')
  const { currentBusiness } = useContext(GlobalContext);
  const [opciones] = useState(null);
  const [data] = useState([])
  const [yearFilter, setYearFilter] = useState(currentYear)
  const fromMonth = 1
  const toMonth = currentMonth
  const businessAPI = new BusinessAPI()
  const [, setLoadingIngresosEgresos] = useState(false)
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [isLoadingEmpresas, setIsLoadingEmpresas] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const fetchClienteProv = useCallback(async () => {
    if (!currentBusiness?.id) {
      console.error('No hay negocio seleccionado');
      setIsLoadingData(false)
      setIsLoadingEmpresas(false)
      return;
    }
    setIsLoadingData(true)
    // Mantiene un solo ciclo visual de carga durante el traspaso a las
    // consultas secundarias de empresas.
    setIsLoadingEmpresas(true)
    setLoadingIngresosEgresos(true)
    try {
      const promises = [];

      for (let month = fromMonth; month <= toMonth; month++) {
        const mm = String(month).padStart(2, '0');

        // Agregar las dos promesas (ingreso y egreso) por cada mes
        const baseParams = {
          businessId: currentBusiness.id,
          month: mm,
          year: yearFilter,
          code: opciones || data,
          linkage: true,
          max: 10000
        };

        promises.push(
          businessAPI.getListSummaryMovementsSpecific({
            ...baseParams,
            type: 'ingreso'
          }).then(res => {
            const movimientosIngreso = res.data?.libros ?? res.data ?? []
            return movimientosIngreso.map(item => ({ ...item, tipo: 'Cliente' }))
          })
        );

        promises.push(
          businessAPI.getListSummaryMovementsSpecific({
            ...baseParams,
            type: 'egreso'
          }).then(res => {
            const movimientosEgreso = res.data?.libros ?? res.data ?? []
            return movimientosEgreso.map(item => ({ ...item, tipo: 'Proveedores' }))
          })
        );
      }

      const results = await Promise.all(promises);
      const combinedResults = results.flat();
      // Ordenar por fecha
      combinedResults.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
      setLoadingIngresosEgresos(true)
      setDataClienteProv(combinedResults);
      setLoadingIngresosEgresos(false)

    } catch (error) {
      console.error('Error al obtener Ingresos/Egresos:', error);
      setDataClienteProv([]);
    }
    setIsLoadingData(false)
  }, [currentBusiness, businessAPI, fromMonth, toMonth, yearFilter, opciones, data]);

  useEffect(() => {
    if (currentBusiness?.id) {
      setDataClienteProv([])
      fetchClienteProv();
    } else {
      setIsLoadingData(false)
      setIsLoadingEmpresas(false)
    }
  }, [currentBusiness, yearFilter]);

  const filteredData = useMemo(() => {
  if (!dataClienteProv?.length) return [];

  const yearStr = String(yearFilter);
  const term = searchTerm.toLowerCase().trim();

  return dataClienteProv
    // 1️⃣ Filtrar por año desde query
    .filter(item => {
      if (!item.query) return false;
      const yearFromQuery = item.query.split('&')[0]?.split('-')[1];
      return yearFromQuery === yearStr;
    })
    // 2️⃣ Filtrar por buscador
    .filter(item => {
      if (!term) return true;

      return (
        (item.nombreCuenta || '').toLowerCase().includes(term) ||
        (item.razonSocial || '').toLowerCase().includes(term) ||
        (item.nombreFolio || '').toLowerCase().includes(term) ||
        (item.rut || '').toLowerCase().includes(term) ||
        (item.montoTotal?.toString() || '').includes(term)
      );
    });
}, [dataClienteProv, searchTerm, yearFilter]);


  return (
   <>
      <div
        className="p-4 mt-2 bg-white rounded-3xl shadow-md flex flex-col overflow-hidden font-sans"
        style={{ height: isMobile ? 'auto' : 'calc(100vh - 11rem)' }}
      >
        
        {!selectedItem ? (
          <>
            <div className="flex flex-wrap mt-1 gap-2 items-center p-4 mb-4 justify-between">
              <div className="flex gap-2">
                <CustomButton
                  className={`rounded-lg font-bold border-2  ${
                    selectedTipo === 'clientes'
                      ? 'bg-accent2 text-white'
                      : 'bg-transparent border text-black'
                  }`}
                  title="Clientes"
                  onClick={() => setSelectedTipo('clientes')}
                />
                <CustomButton
                  className={`rounded-lg font-bold border-2  ${
                    selectedTipo === 'proveedores'
                      ? 'bg-accent2 text-white'
                      : 'bg-transparent border text-black'
                  }`}
                  title="Proveedores"
                  onClick={() => setSelectedTipo('proveedores')}
                />
                <Select options={yearsOptions} defaultValue={yearFilter} onChange={e => setYearFilter(e.target.value)} />
              </div>
              <SearchFilter value={searchTerm} onChange={e => setSearchTerm(e.target.value)}  />
            </div>
            {(isLoadingData || isLoadingEmpresas) && (
              <div className="flex items-center justify-center h-full">
                <Lottie animationData={LoaderAdm} loop style={{ width: 300, height: 300 }} />
              </div>
            )}
            {!isLoadingData && (
              <div className={isLoadingEmpresas ? 'hidden' : 'contents'}>
                <TableListado
                  userMe={userMe}
                  dataClienteProv={filteredData}
                  tipo={selectedTipo}
                  onSelectItem={(item) => setSelectedItem(item)}
                  onLoadingEmpresasChange={setIsLoadingEmpresas}
                />
              </div>
            )}
          </>
          ) : (
          <VistaDetalle
            dataClienteProv={filteredData}
            item={selectedItem}
            yearFilter={yearFilter}
            onVolver={() => setSelectedItem(null)}
          />
          )}
        </div>
      </>
    )
}

export default List
